const getSearchParamsWithLabels = (productName, searchParams) => {
  if (productName === "Reliance IPA") {
    const labels = [
      { label: "Transaction Number:", param: "transactionNo" },
      { label: "Payment Gateway:", param: "gateway" },
      { label: "Proposal Number:", param: "proposalNo" },
      { label: "Policy Number:", param: "policyNo" },
    ];

    const extractedLabels = labels.map(({ label, param }) => ({
      label,
      value: searchParams.get(param) || "N/A",
    }));
    return extractedLabels;
  }
  return [];
};

export default getSearchParamsWithLabels;
